import { HttpInterceptorFn } from '@angular/common/http';
import { GlobalState } from '@modules/settings/types/global-state';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const states = new GlobalState(JSON.parse(localStorage.getItem('app.states') as any) || {});
  const authToken = states.accessToken;

  if (!authToken) {
    return next(req);
  }

  // Clone the request and add the authorization header
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${authToken}`
    }
  });

  // Pass the cloned request with the updated header to the next handler
  return next(authReq);
};
